
jQuery(document).ready(function($){
	
	
	// Global var
    var GLOBAL = {};
    GLOBAL.resizeTimer;
    GLOBAL.isMobile = false;
    GLOBAL.isTablet = false;
	
	
	
	
	// Check if mobile device based on header class display on media queries
	if ( $("#header-mobile").css("display") === 'block') {
		GLOBAL.isMobile = true;
	}else{
		GLOBAL.isMobile = false;
	}
	if ( $("#header .block-menu-block ul.menu li .logo").css("position") === 'absolute') {
		GLOBAL.isTablet = true;
	}else{
		GLOBAL.isTablet = false;
	}
	
	
	
	// Change Navis tel number into a tel link
	$('a.tel').each(function(index) {
		var numberNoNavis = $(this).text().match(/\d/g).join(""); // replace all leading non-digits with nothing
		$(this).attr("href", "tel:"+numberNoNavis );
	});
		
				

	// Scroll To behaviour		
	var backTopLink = $('#header .back-top a');
                
	// Reset all scrollable panes to (0,0)
	$('div.pane').scrollTo( 0 );
	
	// Reset the screen to (0,0)
	$.scrollTo( 0 );
	
	// Back to Top
	backTopLink.click(function(event) {
		event.preventDefault();
		$.scrollTo( 0, 1000, {easing:'easeOutQuint'});
	});
	
	
	
	// Navigation Display (animation + change on scroll)
	var scrollPosition;
	var header = $('#header');
	var logo = $('#header .block-menu-block ul.menu li.menu__item .logo');
	var emblemContent = $('#header .emblem-placeholder').html();
	var backTop = $('#header .back-top');
	var logoParent = logo.parent();
	var headerHeight = $('#header').outerHeight();
	var parentLogoWidth = 200;
	var primaryNavItem = $('#header .block-menu-block ul.menu li.menu__item');

	
	// Clean style applied to nav on tablet formats (triggered on resize)
	if(GLOBAL.isTablet ){
		logoParent.removeAttr("style");
		logo.removeAttr("style");
		header.removeAttr("style");
		backTop.removeAttr("style");
		$('#header .block-menu-block ul.menu li .logo-emblem').removeAttr("style");
	}
	
	
	
	// Bottom Navigation behavior
	$('#footer').bind('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$('#bottom').css('position','static'); 
		} else {
			$('#bottom').css('position','fixed'); 
		}
	});    
	
	
	
	// Top Navigation behavior
		
	
	// Animate menu on first load
	primaryNavItem.each(function( index ) {
		var that = $(this);
		if( !that.children('a').hasClass("logo") ){
			TweenMax.from( that, 1, {opacity: 0, delay: 0.5});
		}
	});
	
	// Add emblem to logo link
	if(!GLOBAL.isTablet ){ logoParent.css({"width": parentLogoWidth+"px"}); }
	logoParent.append(emblemContent);
	var emblemLogo = $('#header .block-menu-block ul.menu li .logo-emblem');
	
	// Change nav base on scroll
	$(window).scroll(function(event) {
		if(!GLOBAL.isMobile && !GLOBAL.isTablet){
			scrollPosition = $(document).scrollTop();
			if (scrollPosition < 50) {
				expandTopNav();                        
			}else{
				collapseTopNav();
			}
		}   
	});
	
	function collapseTopNav() {
		if (!header.hasClass('header-simple')) {
			header.addClass('header-simple');
			TweenMax.to( logo, 0.2, {opacity: 0, onComplete: function(){
					emblemLogo.css({"opacity": 0, "display": "inline-block"});
					backTop.css({"opacity": 0, "display": "block"});
					logo.css("display","none");
					TweenMax.to( header, 0.5, {top: -50, height: headerHeight - 20});
					TweenMax.to( logoParent, 0.5, {width: 60, delay: 0.5, ease: Quint.easeOut});
					TweenMax.to( emblemLogo, 0.5, {opacity: 1, delay: 0.8});
					TweenMax.fromTo( backTop, 0.2, {bottom: -15, opacity: 0}, {bottom: -29, opacity: 1, delay: 0.8});
				} 
			});
		}
	}
		  
	function expandTopNav() {
		if (header.hasClass('header-simple')) {
			header.removeClass('header-simple');
			TweenMax.to( logo, 0.2, {opacity: 0, onComplete: function(){
					logo.css({"opacity": 0, "display": "inline-block"});
					emblemLogo.css("display","none");
					TweenMax.to( header, 0.5, {top: 0, height: headerHeight });
					TweenMax.to( logoParent, 0.5, {width: parentLogoWidth, delay: 0.5, ease: Quint.easeOut});
					TweenMax.to( logo, 0.5, {opacity: 1, delay: 0.8});
					
				}
			});
			TweenMax.to( backTop, 0.2, {bottom: -15, opacity: 0, onComplete: function(){
					backTop.removeAttr("style");
				}
			});
		}
	}

	
	
	
	
	// Mobile Navigation Behavior (open/close)
	var menuButtom = $('.menu-icon-mobile a');
	var mobileMenu = $('#navigation-mobile');
	var seconNavItem = $('#navigation-mobile .menu-block-wrapper > ul.menu > li.menu__item > a');
	var isNavOpen = false;
	
	// MAIN MENU
	menuButtom.click(function(event) {
		event.preventDefault();
		if(isNavOpen){
			collapseMainNav();
		}else{
			expandMainNav();
		}
	});

	function expandMainNav(){
		mobileMenu.slideDown(250);
		menuButtom.addClass("active");
		isNavOpen = true;
	}

	function collapseMainNav(){
		mobileMenu.slideUp(250);
		menuButtom.removeClass("active");
		collapseAllSecondNav();
		isNavOpen = false;
	}
	
	
	// SECOND MENU
	seconNavItem.click(function(event) {
		if ($(this).attr('id') !== "booking"){
			event.preventDefault();
			that = $(this);
			if(that.hasClass("open")){
				collapseAllSecondNav();
			}else{
				collapseAllSecondNav();
				expandSecondNav(that);
			}
		}
	});
	
	function expandSecondNav(item){
		var submenu = item.next("ul.menu");
		submenu.slideDown(250);
		item.addClass("open");
	}
	
	function collapseAllSecondNav(){
		seconNavItem.each(function( index ) {
			var submenu = $(this).next("ul.menu");
			submenu.slideUp(250);
			$(this).removeClass("open");
		});
	}
	
	
	
	
	// Booking Widget
	var bookButton = $('#bottom a#booking');
	var originalBookingText = bookButton.text();

	$('#booking-widget form').validate({
		rules: {
			departureDate: {
				required: true
			}
		}
	});

	bookButton.click( function(){
		$("#booking-widget").slideToggle();
		if(!$(this).hasClass("open")){
			$(this).text('Close');
			$(this).addClass('open');
		}else {
			$(this).text(originalBookingText);
			$(this).removeClass('open');
		}
		return false;
	});
	
	
	$("#booking-widget .arrival").datepicker({
		showAnim: "fadeIn",
		defaultDate: "",
		changeMonth: true,
		numberOfMonths: 2,
		onClose: function( selectedDate ) {
				$( "#booking-widget .departure").datepicker( "option", "minDate", selectedDate );
		}
	}).datepicker("setDate", new Date());

	$("#booking-widget .departure").datepicker({
		showAnim: "fadeIn",
		defaultDate: "",
		changeMonth: true,
		numberOfMonths: 2,
		onClose: function( selectedDate ) {
				$( "#booking-widget .arrival").datepicker( "option", "maxDate", selectedDate );
		}
	});

	$("#booking-widget .adults" ).spinner({ min:1, max: 4 });
	$("#booking-widget .kids" ).spinner({ min:0, max: 4 });
	
	
	
	
	// Email Signup
	var emailForm = $('#email-signup-form');
	emailForm.validate({
		rules: {
			email: {
				required: true,
				email: true
			}
		},
		 submitHandler: function(emailForm) {
			 $('#email-signup-form').append('<input type="hidden" name="account" value="14491" /><input type="hidden" name="password" value="ifx0oyi2g20bqgep6guh" />');
			 emailForm.submit();
		}
	});
	
	
	// tables
	$(".field-type-text-long table td, .field-type-text-with-summary table td").each(function(index) {
                    
		$(this).parents('table').addClass("responTable");

		// Get label of td and add as html5 data attr
		var indexTd = $(this).index();
		var textTh = $.trim($(this).parent().parent().parent().find("thead tr th").eq(indexTd).text());
		if (textTh === "")$(this).addClass("empty-row");
		$(this).attr("data-label",textTh);
	
	});
	
	
	
	
});
